// Define VP globally to prevent reassignment issues
window.VP = window.VP || {};

// Import dependencies and scripts
import "objectFitPolyfill";
import "slick-carousel";
import "waypoints/lib/jquery.waypoints.min.js";

import "./generic/index.js";
import "./components/index.js";
import "./modules/index.js";

// Assign jQuery globally
$ = jQuery;

// Define page-specific and common functions within VP
const loadVpModules = () => {
	// Initialize global functions and components if they exist
	VP.documentEvents?.init();
	VP.breakpoint?.init();
	VP.bodyScroll?.init();
	VP.helpers?.init();
	// VP.blackout?.init(); // DISABLE-BLACKOUT //
	VP.nav?.init();
	VP.featuredHero?.init();
	VP.featuredHeroSlider?.init();
	VP.categoryHero?.init();
	VP.newsletter?.init();
	VP.topPicks?.init();
	VP.socialShare?.init();
	VP.factsModule?.init();
	VP.reveal?.init();
	VP.search?.init();
	VP.googleSearch?.init();
	VP.accordionModule?.init();
	VP.cinematicHero?.init(); ///
	VP.featuredModule?.init();
	VP.experienceModule?.init();
	VP.experienceFullWidthModule?.init();
	VP.quicklinks?.init();
	VP.escClose?.init();
	VP.showMore?.init();
	VP.exploreNeighborhoodModule?.init();
	VP.locationReferenceModule?.init();
	VP.relatedContent?.init();
	VP.generalContentGrid?.init();
	VP.whiteImage?.init();
	VP.resourceModule?.init();
	VP.submenuList?.init();
	VP.subhead?.init();
	VP.modifiers?.init();
	VP.storyTracker?.init();
	VP.brewSort?.init();
	VP.iglazy?.init();
	VP.ttlazy?.init();
	VP.sitewideAlert?.init();
	VP.videoload?.init();
	VP.dayFiltering?.init();
	//console.log('VP object:', window.VP);
};

window.addEventListener("DOMContentLoaded", () => {
	loadVpModules();
});
